
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicles-we-build",
      function () {
        return require("private-next-pages/vehicles-we-build/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicles-we-build"])
      });
    }
  